module.exports = __webpack_public_path__ + "static/media/SVGForbes.d47c504a.svg";